import type { Components } from '@mui/material';
import { alpha } from '@mui/material/styles';

declare module '@mui/material/Button' {
  interface ButtonPropsVariantOverrides {
    extended: true;
    contained: true;
  }
}

const extendedHoverAndActiveStyles = {
  background: '#00344a',
  boxShadow: '0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px 0px rgba(0, 0, 0, 0.3)',
};

const disabledStyles = {
  backgroundColor: 'rgba(0, 40, 58, 0.12)',
  color: 'rgba(0, 40, 58, 0.38)',
  borderColor: 'rgba(255, 255, 255, 0.12)',
};

export const MuiButton: Components['MuiButton'] = {
  styleOverrides: {
    root: {
      fontWeight: '600',
      borderRadius: '100px',
      textTransform: 'none',
    },
    contained: {
      '&.Mui-disabled': {
        backgroundColor: disabledStyles.backgroundColor,
        color: disabledStyles.color,
      },
    },
    containedSecondary: {
      boxShadow: '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)',
    },
    outlined: {
      '&.Mui-disabled': {
        backgroundColor: disabledStyles.backgroundColor,
        color: disabledStyles.color,
        borderColor: disabledStyles.borderColor,
      },
    },
    outlinedSecondary: ({ theme }: { theme: any }) => {
      return {
        backgroundColor: alpha(theme.palette.secondary.light, 0.5),
        borderColor: alpha(theme.palette.secondary.main, 0.5),
        color: theme.palette.primary.main,
        '&:hover': {
          backgroundColor: alpha(theme.palette.secondary.dark, 0.2),
          borderColor: alpha(theme.palette.secondary.main, 0.5),
          color: theme.palette.primary.main,
        },
        '&.Mui-focusVisible .MuiTouchRipple-child': {
          color: theme.palette.secondary.main,
        },
      };
    },
  },
  variants: [
    {
      props: { variant: 'extended' },
      style: {
        width: '232px',
        height: '56px',
        textTransform: 'capitalize',
        boxShadow: '0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px 0px rgba(0, 0, 0, 0.3)',
        '&:hover': {
          background: extendedHoverAndActiveStyles.background,
          boxShadow: extendedHoverAndActiveStyles.boxShadow,
        },
        '&:active': {
          background: extendedHoverAndActiveStyles.background,
          boxShadow: extendedHoverAndActiveStyles.boxShadow,
        },
      },
    },
  ],
};
